// extracted by mini-css-extract-plugin
module.exports = {"table":"ProjectGroups_table__2P0sc","link":"ProjectGroups_link__3XR3t"};